import React from 'react';
import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

const OfflineIndicator: React.FC = () => {
  const isOnline = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-secondary-500 text-white px-4 py-2 z-50 flex items-center justify-center">
      <WifiOff size={16} className="mr-2" />
      <span className="text-sm font-medium">
        You're offline. Some features may not work.
      </span>
    </div>
  );
};

export default OfflineIndicator;
